import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { InputField } from "../../../../Components/formElements/InputField";
import DataTable from "react-data-table-component";
import ERFPaymentSection from "./ERFPaymentSection";
import FileViewerModalForHB from "../../../../Components/FileViewer/FileViewerModalForHB";
import ERFTravelSection from "./ERFTravelSection";

// ── Utility: ISO UTC string → IST display ──────────────────────────────────
const formatIST = (isoString) => {
  if (!isoString) return { date: "--", time: "" };
  const d = new Date(isoString);
  const date = d.toLocaleDateString("en-IN", {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
  const time = d.toLocaleTimeString("en-IN", {
    timeZone: "Asia/Kolkata",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
  return { date, time };
};

const DispatchDetailsModal = ({ show, onHide, dispatchDetails, erfData }) => {
  const [isCardVisible, setCardVisible] = useState(true);
  const toggleCardVisibility = () => setCardVisible(!isCardVisible);

  const [isAccessoriesVisible, setIsAccessoriesVisible] = useState(true);

  const toggleCardVisibility5 = () => {
    setIsAccessoriesVisible(!isAccessoriesVisible);
  };

  const [allItems, setAllItems] = useState([]);
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const [accessoryItems, setAccessoryItems] = useState([]);

  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };

  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  useEffect(() => {
    const combinedItems = [];

    // Add Rent Items
    if (erfData?.rentItems?.length > 0) {
      erfData.rentItems.forEach((item, index) => {
        combinedItems.push({
          ...item,
          itemType: "Rent",
          local_id: combinedItems.length + 1,
        });
      });
    }

    // Add Sale Items
    if (erfData?.saleItems?.length > 0) {
      erfData.saleItems.forEach((item, index) => {
        combinedItems.push({
          ...item,
          itemType: "Sale",
          local_id: combinedItems.length + 1,
        });
      });
    }

    // Add Nursing Items
    if (erfData?.nursingItems?.length > 0) {
      erfData.nursingItems.forEach((item, index) => {
        combinedItems.push({
          ...item,
          itemType: "Nursing",
          local_id: combinedItems.length + 1,
        });
      });
    }

    // Add Service Items
    if (erfData?.serviceItems?.length > 0) {
      erfData.serviceItems.forEach((item, index) => {
        combinedItems.push({
          ...item,
          itemType: "Service",
          local_id: combinedItems.length + 1,
        });
      });
    }

    setAllItems(combinedItems);

    if (erfData?.accessoryItems?.length > 0) {
      setAccessoryItems(erfData.accessoryItems);
    }
  }, [erfData]);

  const getItemTypeColor = (type) => {
    const colors = {
      Rent: "#0d6efd",
      Sale: "#198754",
      Nursing: "#0dcaf0",
      Service: "#fd7e14",
    };
    return colors[type] || "#6c757d";
  };

  const columns = [
    {
      name: "Type",
      cell: (row) => (
        <span
          className="badge"
          style={{
            backgroundColor: getItemTypeColor(row.itemType),
            color: "white",
            padding: "6px 10px",
            borderRadius: "5px",
          }}
        >
          {row.itemType}
        </span>
      ),
      width: "80px",
    },
    {
      name: "Material",
      cell: (row) => (
        <div>
          <p className="fw-bold m-0">{row.materialDescription}</p>
          <p className="m-0 text-muted">{row.materialCode}</p>
        </div>
      ),
      width: "220px",
    },
    {
      name: "Qty",
      cell: (row) => (
        <div>
          <p className="m-0 fw-bold">{row.orderedQuantity}</p>
          <p className="m-0 text-muted">{row.orderUnitOfMeasure}</p>
        </div>
      ),
      width: "100px",
    },
    // {
    //   name: "Rent / Day",
    //   selector: (row) => row.rentPerDay,
    //   width: "110px",
    // },
    {
      name: "Days",
      selector: (row) => row.days,
      width: "80px",
    },
    {
      name: "Net Value",
      selector: (row) => row.netValue,
      width: "110px",
    },
    {
      name: "Tax %",
      selector: (row) => row.taxPercentage,
      width: "90px",
    },
    {
      name: "Gross Value",
      selector: (row) => row.grossValue,
      width: "120px",
    },
    {
      name: "From Date",
      selector: (row) => row.fromDate,
      width: "120px",
    },
    {
      name: "To Date",
      selector: (row) => row.toDate,
      width: "120px",
    },
    // {
    //   name: "Storage",
    //   selector: (row) => row.storageLocn,
    //   width: "130px",
    // },
    {
      name: "Status",
      cell: (row) => (
        <span
          className="badge"
          style={{
            backgroundColor:
              row.status === "In Progress" ? "#ffc107" : "#28a745",
            color: "black",
            padding: "6px 10px",
            borderRadius: "10px",
          }}
        >
          {row.status}
        </span>
      ),
      width: "130px",
    },
    {
      name: "Dispatched Date",
      cell: (row) => (
        <InputField
          className="inputBox"
          type="date"
          name="disPatchedDate"
          value={row.disPatchedDate || ""}
          disabled
        />
      ),
      width: "160px",
    },
    {
      name: "Dispatched Time",
      cell: (row) => (
        <InputField
          className="inputBox"
          type="time"
          name="disPatchedTime"
          value={row.disPatchedTime || ""}
          disabled
        />
      ),
      width: "150px",
    },
    {
      name: "Erf Status",
      cell: (row) => (
        <span
          className="badge"
          style={{
            backgroundColor:
              row.erfStatus === "Dispatched" ? "#28a745" : "#ffc107",
            color: "white",
            padding: "6px 10px",
            borderRadius: "10px",
          }}
        >
          {row.erfStatus || "—"}
        </span>
      ),
      width: "130px",
    },
  ];

  // Add after the columns definition in DispatchDetailsModal
  const accessoryDetailColumns = [
    {
      name: "Accessory Product",
      cell: (row) => (
        <div>
          <p className="fw-bold m-0">{row?.materialDescription}</p>
          <p className="m-0 text-muted">{row?.materialCode}</p>
        </div>
      ),
      width: "250px",
    },
    {
      name: "Barcode",
      cell: (row) => (
        <div>
          <p className="fw-bold m-0">{row?.barcode || "Not Assigned"}</p>
        </div>
      ),
      width: "180px",
    },

    {
      name: "Qty",
      cell: (row) => (
        <div>
          <p className="m-0 fw-bold">{row?.orderedQuantity}</p>
          <p className="m-0 text-muted">{row?.orderUnitOfMeasure}</p>
        </div>
      ),
      width: "120px",
    },
    {
      name: "Brand",
      cell: (row) => <span>{row?.brand || "--"}</span>,
      width: "120px",
    },
    {
      name: "Group",
      cell: (row) => (
        <span className="text-muted">{row?.materialGroup || "--"}</span>
      ),
      width: "180px",
    },
    {
      name: "Dispatched Date",
      cell: (row) => (
        <InputField
          className="inputBox"
          type="date"
          name="disPatchedDate"
          value={row.disPatchedDate || ""}
          disabled
        />
      ),
      width: "160px",
    },
    {
      name: "Dispatched Time",
      cell: (row) => (
        <InputField
          className="inputBox"
          type="time"
          name="disPatchedTime"
          value={row.disPatchedTime || ""}
          disabled
        />
      ),
      width: "160px",
    },
  ];

  const assignmentHistoryColumns = [
    {
      name: "Assigned Date",
      selector: (row) => row?.assignDateAndTime || "--",
      cell: (row) => {
        const { date, time } = formatIST(row?.assignDateAndTime);
        return (
          <div>
            <p className="m-0 fw-medium">{date}</p>
            <p className="m-0 text-muted" style={{ fontSize: "11px" }}>
              {time}
            </p>
          </div>
        );
      },
      sortable: true,
      width: "150px",
    },
    {
      name: "Service Executive",
      selector: (row) => row?.serviceProviderName || "--",
      cell: (row) => (
        <div>
          <p className="m-0 fw-bold">{row?.serviceProviderName || "--"}</p>
          <p className="m-0 text-muted" style={{ fontSize: "11px" }}>
            {row?.serviceProviderCode || ""}
          </p>
        </div>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Category",
      selector: (row) => row?.serviceAssignCategory || "--",
      width: "150px",
    },
    {
      name: "Remark",
      selector: (row) => row?.serviceAssignCategoryDescription || "--",
      cell: (row) => <p>{row?.serviceAssignCategoryDescription || "--"}</p>,
      sortable: true,
      width: "250px",
    },
    {
      name: "Assigned By",
      selector: (row) => row?.assignedBy || "--",
      cell: (row) => (
        <span className="fw-medium">{row?.assignedBy || "--"}</span>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Collect Money",
      selector: (row) => row?.shouldCollectMoney,
      cell: (row) => (
        <span
          className={
            row?.shouldCollectMoney ? "text-success fw-bold" : "text-muted"
          }
        >
          {row?.shouldCollectMoney ? "Yes" : "No"}
        </span>
      ),
      width: "120px",
    },
    {
      name: "Job Status",
      cell: (row) => {
        const status = row?.jobStatus || "Pending";
        const badgeColor =
          status === "Done"
            ? "#28a745"
            : status === "Not Done"
              ? "#dc3545"
              : "#ffc107";
        return (
          <span
            className="badge"
            style={{
              backgroundColor: badgeColor,
              color: status === "Pending" ? "black" : "white",
              padding: "6px 10px",
              borderRadius: "10px",
            }}
          >
            {status}
          </span>
        );
      },
      width: "130px",
    },
    {
      name: "Remarks",
      selector: (row) => row?.jobStatusRemarks || "--",
      width: "200px",
    },
  ];

  return (
    <Modal show={show} onHide={onHide} size="xl" centered backdrop="static">
      <Modal.Header
        closeButton
        style={{ background: "#f0f4f8", borderBottom: "1px solid #c9d8e8" }}
      >
        <Modal.Title
          style={{ color: "#2d6a9f", fontWeight: 700, fontSize: "16px" }}
        >
          <i className="bi bi-truck me-2"></i>Dispatch Details
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* ── Accordion 1: Dispatch Header Details ── */}
        {!dispatchDetails || dispatchDetails.length === 0 ? (
          <div className="text-center py-4">
            <i className="bi bi-inbox display-5 text-muted d-block mb-2"></i>
            <p className="text-muted">No Dispatch Details found.</p>
          </div>
        ) : (
          dispatchDetails.map((detail, index) => (
            <div
              className="accordion mb-3"
              id={`accordionDispatch_${index}`}
              key={index}
            >
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i className="bi bi-chevron-down"></i>
                    </Col>
                    <Col xs={1} md={2} lg={2} className="text-center logoBtn">
                      <span className="iconLogo">DD</span>
                    </Col>
                    <Col xs={12} md={7} lg={7}>
                      <span className="headerTitle">Dispatch #{index + 1}</span>
                      <span className="subHeaderTitle">
                        {detail.dispatchDate} | {detail.dispatchTime}
                      </span>
                    </Col>
                    <Col xs={12} md={2} lg={2} className="headerButtonAlign">
                      {detail.dispatchErfStatus && (
                        <span
                          style={{
                            background: "#e8f8ee",
                            color: "#1a6b35",
                            border: "1px solid #28a745",
                            borderRadius: "20px",
                            padding: "3px 14px",
                            fontSize: "12px",
                            fontWeight: 600,
                          }}
                        >
                          ✓ {detail.dispatchErfStatus}
                        </span>
                      )}
                    </Col>
                  </Row>
                </h2>

                <div className="accordion-collapse collapse show visible">
                  <div className="accordion-body">
                    <Row>
                      <Col
                        lg={3}
                        md={6}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Truck No"
                          name="truckNo"
                          value={detail.truckNo || ""}
                          disabled
                        />
                      </Col>
                      <Col
                        lg={3}
                        md={6}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Driver Name"
                          name="driverName"
                          value={detail.driverName || ""}
                          disabled
                        />
                      </Col>
                      <Col
                        lg={3}
                        md={6}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Contact Number"
                          name="contactNumber"
                          value={detail.contactNumber || ""}
                          disabled
                        />
                      </Col>
                      <Col
                        lg={3}
                        md={6}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Dispatch Vehicle"
                          name="dispatchVehicle"
                          value={detail.dispatchVehicle || ""}
                          disabled
                        />
                      </Col>
                      <Col
                        lg={3}
                        md={6}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Pincode"
                          name="addressPincode"
                          value={detail.addressPincode || ""}
                          disabled
                        />
                      </Col>
                      <Col
                        lg={3}
                        md={6}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Dispatch Date"
                          name="dispatchDate"
                          value={detail.dispatchDate || ""}
                          type="date"
                          disabled
                        />
                      </Col>
                      <Col
                        lg={3}
                        md={6}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Dispatch Time"
                          name="dispatchTime"
                          value={detail.dispatchTime || ""}
                          type="time"
                          disabled
                        />
                      </Col>
                      <Col
                        lg={3}
                        md={6}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Dispatch Remark"
                          name="erfDispatchRemark"
                          value={detail.erfDispatchRemark || ""}
                          disabled
                        />
                      </Col>
                      <Col
                        lg={6}
                        md={6}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Dispatch Address"
                          name="dispatchAddress"
                          value={detail.dispatchAddress || ""}
                          disabled
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}

        {/* ── Accordion 2: All Line Items (Combined) ── */}
        <div className="accordion mt-2" id="accordionLineItems">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility}
                  ></i>
                </Col>
                <Col xs={1} md={2} lg={2} className="text-center logoBtn">
                  <span className="iconLogo">LS</span>
                </Col>
                <Col xs={12} md={8} lg={8}>
                  <span className="headerTitle">Line Items</span>
                  <span className="subHeaderTitle">
                    {allItems.length} items (Rent, Sale, Nursing, Service)
                  </span>
                </Col>
                <Col xs={12} md={2} lg={2} className="headerButtonAlign"></Col>
              </Row>
            </h2>

            <div
              className={`accordion-collapse collapse show ${
                isCardVisible ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    {allItems.length > 0 ? (
                      <DataTable
                        title=""
                        columns={columns}
                        data={allItems}
                        pagination
                      />
                    ) : (
                      <p className="text-muted text-center py-3">
                        No items found
                      </p>
                    )}
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>

        {erfData?.accessoryItems?.length > 0 && (
          <div className="accordion mt-4" id="accordionAssignHistory">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <Row className="accordion-button">
                  <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                    <i
                      className={`bi ${
                        isAccessoriesVisible
                          ? "bi-chevron-right"
                          : "bi-chevron-down"
                      }`}
                      onClick={() =>
                        toggleCardVisibility5(!isAccessoriesVisible)
                      }
                    ></i>
                  </Col>
                  <Col xs={1} md={2} lg={2} className="text-center logoBtn">
                    <span className="iconLogo">AL</span>
                  </Col>

                  <Col xs={8} md={8} lg={8}>
                    <span className="headerTitle">Accessories List</span>
                    <span className="subHeaderTitle">
                      View of Line Accessories Items List and Status
                    </span>
                  </Col>
                </Row>
              </h2>

              <div
                className={`accordion-collapse collapse show ${
                  isAccessoriesVisible ? "visible" : ""
                }`}
              >
                <div className="accordion-body p-0">
                  <DataTable
                    title=""
                    columns={accessoryDetailColumns}
                    data={accessoryItems}
                    pagination
                    noDataComponent={
                      <div className="p-3 text-center text-muted">
                        No accessories found
                      </div>
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ── Payment Section (read-only in details view) ────────── */}
        {erfData?.documentNumber && (
          <ERFPaymentSection
            documentNumber={erfData.documentNumber}
            allowAddBilling={false}
            allowAddSecurity={false}
            allowAddCreditNote={false}
            allowUpdatePayentButton={false}
          />
        )}

        <ERFTravelSection
          travelHistory={erfData?.travelHistory ?? []}
          erfStatusCode={erfData?.erfStatusCode ?? ""}
          onSave={null}
          onConfirmRow={null}
          disabled={true}
        />

        {/* ── Supporting Documents (view-only) ───────────────────── */}
        {dispatchDetails?.some((d) => d.dispatchDocumentsUpload) && (
          <div className="accordion mt-3" id="accordionSupportingDocsDetail">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <Row className="accordion-button">
                  <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                    <i className="bi bi-chevron-down" />
                  </Col>
                  <Col xs={1} md={2} lg={2} className="text-center logoBtn">
                    <span className="iconLogo">SD</span>
                  </Col>
                  <Col xs={12} md={8} lg={8}>
                    <span className="headerTitle">
                      Dispatch/Service Supporting Documents
                    </span>
                    <span className="subHeaderTitle">
                      Attached dispatch documents
                    </span>
                  </Col>
                </Row>
              </h2>
              <div className="accordion-collapse collapse show visible">
                <div className="accordion-body">
                  <Row>
                    {dispatchDetails.map((detail, index) =>
                      detail.dispatchDocumentsUpload ? (
                        <Col
                          key={index}
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding d-flex align-items-center gap-2"
                        >
                          <span
                            className="fw-medium text-muted"
                            style={{ fontSize: "13px" }}
                          >
                            Dispatch #{index + 1}:
                          </span>
                          {detail.dispatchDocumentsUpload ? (
                            <img
                              src="assets/img/newIcons/attached-file.png"
                              className="attachmentIcon"
                              alt="View document"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                handleViewFile(detail.dispatchDocumentsUpload)
                              }
                            />
                          ) : (
                            <span
                              className="text-muted"
                              style={{ fontSize: "12px" }}
                            >
                              No document attached
                            </span>
                          )}
                        </Col>
                      ) : null,
                    )}
                  </Row>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ── EwayBill Details (view-only) ────────────────────────── */}
        {dispatchDetails?.some((d) => d.ewayBillNo || d.ewayBillDate) && (
          <div className="accordion mt-3" id="accordionEwayDetail">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <Row className="accordion-button">
                  <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                    <i className="bi bi-chevron-down" />
                  </Col>
                  <Col xs={1} md={2} lg={2} className="text-center logoBtn">
                    <span className="iconLogo">ED</span>
                  </Col>
                  <Col xs={12} md={8} lg={8}>
                    <span className="headerTitle">EwayBill Status Details</span>
                    <span className="subHeaderTitle">
                      EwayBill Status Details & Information
                    </span>
                  </Col>
                </Row>
              </h2>
              <div className="accordion-collapse collapse show visible">
                <div className="accordion-body">
                  {dispatchDetails.map((detail, index) =>
                    detail.ewayBillNo || detail.ewayBillDate ? (
                      <Row key={index} className="mb-2">
                        <Col
                          xs={12}
                          className="text-muted fw-semibold mb-1"
                          style={{ fontSize: "13px" }}
                        >
                          Dispatch #{index + 1}
                        </Col>
                        <Col
                          lg={3}
                          md={6}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Eway Date"
                            name="ewayBillDate"
                            type="date"
                            value={detail.ewayBillDate || ""}
                            disabled
                          />
                        </Col>
                        <Col
                          lg={3}
                          md={6}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Eway Bill No"
                            name="ewayBillNo"
                            value={detail.ewayBillNo || ""}
                            disabled
                          />
                        </Col>
                        {detail.ewayBillUpload && (
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding d-flex align-items-center gap-2"
                          >
                            <span
                              className="text-muted"
                              style={{ fontSize: "13px" }}
                            >
                              Delivery Challan:
                            </span>
                            <img
                              src="assets/img/newIcons/attached-file.png"
                              className="attachmentIcon"
                              alt="eway attachment"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                handleViewFile(detail.ewayBillUpload)
                              }
                            />
                          </Col>
                        )}
                      </Row>
                    ) : null,
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
        {/* ── SE Travel Details (view-only) ─────────────────────────── */}
        {erfData?.seTravelDetails && (
          <div className="accordion mt-3" id="accordionSETravelDetail">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <Row className="accordion-button">
                  <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                    <i className="bi bi-chevron-down" />
                  </Col>
                  <Col xs={1} md={2} lg={2} className="text-center logoBtn">
                    <span className="iconLogo">SE</span>
                  </Col>
                  <Col xs={12} md={8} lg={8}>
                    <span className="headerTitle">SE Travel Details</span>
                    <span className="subHeaderTitle">
                      Transport & Vehicle Information
                    </span>
                  </Col>
                </Row>
              </h2>

              <div className="accordion-collapse collapse show visible">
                <div className="accordion-body">
                  <Row>
                    <Col
                      lg={3}
                      md={6}
                      className="commTopButtonRightLeftPadding"
                    >
                      <InputField
                        className="inputBox"
                        label="Transport ID"
                        value={erfData.seTravelDetails.transportId || "--"}
                        disabled
                      />
                    </Col>
                    <Col
                      lg={3}
                      md={6}
                      className="commTopButtonRightLeftPadding"
                    >
                      <InputField
                        className="inputBox"
                        label="Transport Mode"
                        value={erfData.seTravelDetails.transportMode || "--"}
                        disabled
                      />
                    </Col>
                    <Col
                      lg={3}
                      md={6}
                      className="commTopButtonRightLeftPadding"
                    >
                      <InputField
                        className="inputBox"
                        label="Transporter Name"
                        value={erfData.seTravelDetails.transporterName || "--"}
                        disabled
                      />
                    </Col>
                    <Col
                      lg={3}
                      md={6}
                      className="commTopButtonRightLeftPadding"
                    >
                      <InputField
                        className="inputBox"
                        label="Transport Distance (km)"
                        value={
                          erfData.seTravelDetails.transportDistance || "--"
                        }
                        disabled
                      />
                    </Col>
                    <Col
                      lg={3}
                      md={6}
                      className="commTopButtonRightLeftPadding"
                    >
                      <InputField
                        className="inputBox"
                        label="Transport Doc No"
                        value={erfData.seTravelDetails.transportDocNo || "--"}
                        disabled
                      />
                    </Col>
                    <Col
                      lg={3}
                      md={6}
                      className="commTopButtonRightLeftPadding"
                    >
                      <InputField
                        className="inputBox"
                        label="Transport Doc Date"
                        type="date"
                        value={erfData.seTravelDetails.transportDocDate || ""}
                        disabled
                      />
                    </Col>
                    <Col
                      lg={3}
                      md={6}
                      className="commTopButtonRightLeftPadding"
                    >
                      <InputField
                        className="inputBox"
                        label="Vehicle No"
                        value={erfData.seTravelDetails.vehicleNo || "--"}
                        disabled
                      />
                    </Col>
                    <Col
                      lg={3}
                      md={6}
                      className="commTopButtonRightLeftPadding"
                    >
                      <InputField
                        className="inputBox"
                        label="Vehicle Type"
                        value={erfData.seTravelDetails.vehicleType || "--"}
                        disabled
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* ── Assignment History ─────────────────────────────────── */}
        {erfData?.assignedServiceExecutives?.length > 0 && (
          <div className="accordion mt-4" id="accordionAssignHistoryDetail">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <Row className="accordion-button">
                  <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                    <i className="bi bi-chevron-down" />
                  </Col>
                  <Col xs={1} md={2} lg={2} className="text-center logoBtn">
                    <span className="iconLogo">AH</span>
                  </Col>
                  <Col xs={8} md={8} lg={8}>
                    <span className="headerTitle">
                      Service Executive Assignment History
                    </span>
                    <span className="subHeaderTitle">
                      Previously assigned service executives
                    </span>
                  </Col>
                </Row>
              </h2>
              <div className="accordion-collapse collapse show visible">
                <div className="accordion-body p-0">
                  <DataTable
                    columns={assignmentHistoryColumns}
                    data={[...erfData.assignedServiceExecutives].reverse()}
                    pagination
                    noDataComponent={
                      <div className="p-3 text-muted text-center">
                        No assignment history found
                      </div>
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Col xs={12} md={8} lg={3} className="d-flex justify-content-end">
          <button className="btnTable btn-danger" onClick={onHide}>
            Close
          </button>
        </Col>
      </Modal.Footer>

      <FileViewerModalForHB
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
        showDelete={false}
      />
    </Modal>
  );
};

export default DispatchDetailsModal;
